module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic13.486ee27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic13.png
// module id = 531
// module chunks = 1